









import { genVuexComputeds } from '@/main/pages/editFactory';
import { Cell, Table, getColumnsRowMapObject } from '@/main/utils/table';
import { printButton } from '@/main/utils/tableOperations';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { store } from '../../store/edit';
import { vydejkaTisk } from './api';

export default EditStoreMixin.extend({
	name: 'Vydejky',
	components: {
		DmsPdfDialog,
	},
	data() {
		return {
			vydejkaNdFlag: false,
			printButton,
			vydejkaTisk,
			showTiskDialog: false,
			zakazkovyListTiskFilter: {},
			pdfProvider: null as ((id: number) => Promise<any>) | null,
			vydejkaId: null as number | null,
		};
	},
	computed: {
		...genVuexComputeds(store),
		vydejka(): Table {
			return this.vydejkaNdFlag ? this.dependentTables.VydejkaNd : this.dependentTables.Vydejka;
		},
		extraButtons(): {} {
			return ((this.dmsSys.Parts_Order_Cancel_Prp) || this.isZakazkaDisabled) ? { ...printButton(this.printVydejka) } : {};
		},
		vydejkaFilter(): { Id: number } {
			return {
				Id: this.vydejkaId!,
			};
		},
		rowsLength(): number {
			return this.vydejka.rows.length;
		},
	},
	watch: {
		rowsLength() {
			(this.$refs.table as any).refreshLayout();
		},
	},
	methods: {
		async printVydejka(e: Event, cells: Cell[]) {
			[this.vydejkaId] = cells;
			this.showTiskDialog = true;
		},
	},
});
